import { render, staticRenderFns } from "./DevBasic.vue?vue&type=template&id=33294f54&scoped=true"
import script from "./DevBasic.vue?vue&type=script&lang=js"
export * from "./DevBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33294f54",
  null
  
)

export default component.exports